<template>
  <footer id="footer" class="footer">
    <div class="footer__wrapper">
      <FooterInfo class="footer__info" />
      <div class="footer__bank-protection">
        <FooterBank class="footer__bank" />
        <FooterProtection class="footer__protection" />
      </div>
      <FooterNav class="footer__nav" />
      <FooterTags class="footer__block footer__tags" />
      <FooterPayments class="footer__block footer__payments" />
      <FooterCopyright class="footer__block footer__copyright" />
    </div>
  </footer>
</template>

<script>
import FooterInfo from '@/components/App/AppFooter/FooterInfo'
import FooterBank from '@/components/App/AppFooter/FooterBank'
import FooterProtection from '@/components/App/AppFooter/FooterProtection'
import FooterNav from '@/components/App/AppFooter/FooterNav'
import FooterTags from '@/components/App/AppFooter/FooterTags'
import FooterPayments from '@/components/App/AppFooter/FooterPayments'
import FooterCopyright from '@/components/App/AppFooter/FooterCopyright'

export default {
  name: 'AppFooter',
  components: {
    FooterInfo,
    FooterBank,
    FooterProtection,
    FooterNav,
    FooterTags,
    FooterPayments,
    FooterCopyright,
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
